module.exports = __webpack_public_path__ + "static/Unschool Logo Horizontal White (1)-34c0564e7a6f83682d9197a2d32b162e.png";